const setForm = () => {
  const checkbox = document.querySelector('.js-agree-check');

  if(checkbox !== null) {
    const btn = document.querySelector('.js-form-submit .btn')

    checkbox.addEventListener('change', function() {
      if(this.checked) {
        btn.classList.remove('disabled')
      } else {
        btn.classList.add('disabled')
      }
    })
  }
};

export default setForm;
